import React, { useState } from "react";
import { showError, showSuccess } from "utils/notifications";
import { createPhrase } from "adminApi/PhraseListApi/PhraseList";
import { validateField, validateForm } from "utils/validation";
import { PhraseRules } from "validation/ValidationRules";

const CreatePhrese = ({ setRefresh, canCreate }) => {
  const [values, setValues] = useState({ phrase: "" });
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  if (!canCreate) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    const errorMsg = validateField(name, value, PhraseRules);
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(values, PhraseRules);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      showError(Object.values(validationErrors)[0]);
      return;
    }

    setLoading(true);
    try {
      const response = await createPhrase({ phrase: values.phrase.trim() });
      if (response.data.success) {
        showSuccess(response.data.message || "Phrase added successfully");
        setValues({ phrase: "" });
        setRefresh((prev) => !prev);
      } else {
        showError(response.data.error || "Error adding phrase");
      }
    } catch (err) {
      console.error("Create phrase failed", err);
      showError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-3 align-items-center">
        <div className="col-lg-6">
          <input
            type="text"
            name="phrase"
            value={values.phrase}
            onChange={handleChange}
            placeholder="Add Phrase"
            className={`form-control ${errors.phrase ? "is-invalid" : ""}`}
            disabled={loading}
          />
          {errors.phrase && (
            <div className="invalid-feedback">{errors.phrase}</div>
          )}
        </div>
        <div className="col-lg-6 d-flex justify-content-end align-items-center">
          <button
            type="submit"
            className="btn btn-primary px-4"
            disabled={!values.phrase.trim() || loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Creating...
              </>
            ) : (
              "Create"
            )}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreatePhrese;
